<ng-container *transloco="let t;">
    <div class="d-flex align-content-center justify-content-between w-100">
        <div class="input-group input-group-merge">
            <div class="input-group-prepend">
                                  <span class="input-group-text"><i
                                          data-feather="search"></i></span>
            </div>
            <input type="text" class="form-control" id="search"
                   [disabled]="loading"
                   [(ngModel)]="searchString"
                   [placeholder]="t('Search placeholder (documents advanced filters) - Search people and company data')"
                   (keyup.enter)="onSearchChange(searchString)"
                   aria-label="Search..."
                   aria-describedby="search"
            />
        </div>
    </div>
    <ng-scrollbar autoHeightDisabled="false" visibility="hover" class="advanceFilterInnerContainer">
        <div class="mt-2">
            @if (loading) {
                <app-skeleton [loop]="8" [section]="'advanced_filters'"></app-skeleton>
            } @else {
                @for (category of items | keyvalue; track category.key) {
                    <h5 class="px-25 py-50 m-0 filterTitleText text-muted">{{t( ('Document and Contract Cards - listview - filters - advanced filters - group - '+  (category.key | filterGroupName))) }}</h5>
                    @for (filterData of category.value; track filterData) {
                        <a ngbDropdownItem href="javascript:void(0);" (click)="addFilter(filterData)">
                            <i *ngIf="filterData.icon" [data-feather]="filterData.icon" class="me-50"></i>
                            <span>{{ filterData.text }}</span>
                        </a>
                    }
                } @empty {
                    {{ t('Empty filters (documents advanced filters) - There is no filters available') }}
                }
            }
        </div>
    </ng-scrollbar>
</ng-container>
